import { downloadCommonImageUrl } from '../service';
import type { CommonImageItemType } from '../types';

/** 弹窗确认时解析镜像地址：容器用 dockerRefUrl，通用镜像走下载接口 */
export async function resolveImageSelectConfirmUrl(
  variant: 'common' | 'container',
  item: CommonImageItemType,
): Promise<string | undefined> {
  if (variant === 'container') {
    const dockerRefUrl = String(item.dockerRefUrl ?? '').trim();
    return dockerRefUrl || undefined;
  }

  const imageId = item.id ?? item.key;
  if (!imageId || !item.abstractId) return undefined;
  return downloadCommonImageUrl(item.abstractId, imageId);
}
